module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/axios/index.js
// module id = 98
// module chunks = 4011265886480 35783957827783 271073383855010